import { render, staticRenderFns } from "./ServiceInfoStyling.vue?vue&type=template&id=f4be4bc6&scoped=true&"
import script from "./ServiceInfoStyling.vue?vue&type=script&lang=js&"
export * from "./ServiceInfoStyling.vue?vue&type=script&lang=js&"
import style0 from "./ServiceInfoStyling.vue?vue&type=style&index=0&id=f4be4bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4be4bc6",
  null
  
)

export default component.exports